import { render, staticRenderFns } from "./ReportingChannelForm.vue?vue&type=template&id=16a90fd7&scoped=true&"
import script from "./ReportingChannelForm.vue?vue&type=script&lang=js&"
export * from "./ReportingChannelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a90fd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a90fd7')) {
      api.createRecord('16a90fd7', component.options)
    } else {
      api.reload('16a90fd7', component.options)
    }
    module.hot.accept("./ReportingChannelForm.vue?vue&type=template&id=16a90fd7&scoped=true&", function () {
      api.rerender('16a90fd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/ReportingChannelForm.vue"
export default component.exports